import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
import customSetting from "../../../public/config/customSetting.json";
import ModifyCustomSetting from "../../../src/debugControll";
Vue.prototype.apiUrl = customSetting.apiUrl;
let baseApi = customSetting.apiUrl;
// const loginController = customSetting.loginController;
// const getLogin = customSetting.getLogin;
// const postLogin = customSetting.postLogin;
self.customSetting = ModifyCustomSetting({ ...customSetting });
// const isDevelop = true;
var getLogin;
var postLogin;
// if (isDevelop) {
//   getLogin = customSetting.loginController;
//   postLogin = customSetting.loginController;
// } else {
//   getLogin = customSetting.getLogin;t
//   postLogin = customSetting.postLogin;
// }
getLogin = self.customSetting.getLogin;
postLogin = self.customSetting.postLogin;
baseApi = self.customSetting.apiUrl;
export default {
  getValidate: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getLogin}/Validate`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addRegister: (context, data) => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            formData.append(key, item);
          });
        } else {
          formData.append(key, value);
        }
      }
    });
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postLogin}/ApplyVendor`, formData, {
          //一定要指定
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getNewVendorInfo: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getLogin}/GetNewVendorInfo`)
        .then((res) => {
          const data = res.data.data;
          context.commit("GET_NEW_VENDOR_INFO", data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  GetVenResultsList: (context, { s_id, id }) => {
    return new Promise((resolve, reject) => {
      const apiUrl = `${baseApi}/${getLogin}/GetVenResults?s_id=${s_id}&id=${id}`;
      console.log("Calling GetVenResults with token:", apiUrl);

      axios
        .get(apiUrl)
        .then((res) => {
          console.log("=== GetVenResults API Response ===");
          console.log("Full response:", res);
          console.log("Response data:", res.data);
          console.log("Response status:", res.status);
          console.log("=== End GetVenResults API Response ===");

          resolve(res.data); // 確保回傳 res.data 而不是整個 res
        })
        .catch((err) => {
          console.error("GetVenResults error:", err.response);
          reject(err);
        });
    });
  },

  getForgetPassword: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getLogin}/ForgetPass?s_id=${obj.s_id}&email=${obj.email}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  chkConsentTodo: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getLogin}/LoginConSent?s_id=${obj.s_id}&id=${obj.id}`
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getIndexInfo: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getLogin}/Init`)
        .then((res) => {
          const data = res.data.data;
          context.commit("GET_INDEX_INFO", data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  changePswd: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postLogin}/ChgPD`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updConsentData: (context, { s_id, id }) => {
    return new Promise((resolve, reject) => {
      console.log("updConsentData called with:", { s_id, id });

      const apiUrl = `${baseApi}/${getLogin}/UpdConsentData?s_id=${s_id}&id=${id}`;
      console.log("updConsentData URL:", apiUrl);

      axios({
        method: "GET",
        url: apiUrl,
      })
        .then((res) => {
          console.log("updConsentData success:", res);
          resolve(res.data);
        })
        .catch((err) => {
          console.error("=== updConsentData Error Debug ===");
          console.error("Full error object:", err);
          console.error("Error message:", err.message);
          console.error("Error response:", err.response);
          console.error("Error status:", err.response?.status);
          console.error("Error data:", err.response?.data);
          console.error("=== End updConsentData Error Debug ===");
          reject(err);
        });
    });
  },
  getDownloadTerms: () => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${baseApi}/${getLogin}/DownloadTerms`,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getDownloadPdf: () => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${baseApi}/${getLogin}/DownloadPDF`,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getDownloadOrgPdf: () => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${baseApi}/${getLogin}/DownloadOrgPDF`,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  qrySideBar: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getLogin}/QrySideBar`)
        .then((res) => {
          context.commit("QRY_SIDEBAR", res);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  logout: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getLogin}/Logout`)
        .then(() => resolve())
        .catch((err) => reject(err));
    });
  },
};
